<div>
  <kl-publish-sms-form (smsCreated)="onSmsSent($event)"></kl-publish-sms-form>
</div>
